import { vslApi } from '@/api';

export default {
  upload(data) {
    return vslApi.post('/v1/upload/', data);
  },
};
